import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Alarm/Object_Detection/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmLivestreamPerm';
import SettingsTable from 'components/Web_User_Interface/1440p_Series/Alarm/Object_Detection/settingsTable';
import YoutubeVideoCardAlarm from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/YoutubeVideoCardAlarm';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  SettingsTable,
  YoutubeVideoCardAlarm,
  BreadCrumbs,
  SEOHelmet,
  React
};